import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Company } from '../models/company-model';
import { UserData } from '../models/user/user-data.model';
import { DataService } from './data.service';
import { EnvironmentService } from 'projects/shared/services/environment.service';

@Injectable()
export class UserService {

  constructor(private readonly _dataService: DataService,
    private readonly _environmentService: EnvironmentService,
  ) { }

  getLoggedInUserData = (): Observable<UserData> => {
    return this._dataService.get('api/auth/userdata').pipe(
      map((user) => {
        if (user.avatar === 'content/img/avatars/male.png') {
          user.avatar = 'assets/images/male.png';
        }
        return user;
      })
    );
  };

  getUserCompany = (userName: string): Observable<Array<Company>> => {
    const url = this._environmentService.apiInfo.authApiBaseUrl + '/api/auth/AllCompanyForUserName?username=' + encodeURIComponent(userName);
    return this._dataService.post(
      url,
      {},
      false
    );
  };
}
